var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isMounted)?_c('investor-bank-accounts',{attrs:{"is-moral":_vm.isMoral,"person-type":_vm.investorType,"user-id":_vm.currentInvestorUserId,"has-backoffice-access":_vm.hasBackofficeAccess,"user-data":_vm.base}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }